import { render, staticRenderFns } from "./GaleriaImagenes.vue?vue&type=template&id=366c0a98&scoped=true"
import script from "./GaleriaImagenes.vue?vue&type=script&lang=ts"
export * from "./GaleriaImagenes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c0a98",
  null
  
)

export default component.exports